import { NotifyErrorWrapper } from '@/helpers/core/notifications'
import { getAllPartStatuses, getMinerStatuses } from '@/services/rc.service'
import { useQuery } from '@tanstack/vue-query'

export const useStatuses = () => {
  const { data: minerStatuses } = useQuery({
    queryKey: ['miner-statuses'],
    queryFn: () => getMinerStatuses().catch(NotifyErrorWrapper('Failed to fetch possible miner statuses')),
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  })

  const { data: partStatuses } = useQuery({
    queryKey: ['part-statuses'],
    queryFn: () => getAllPartStatuses().catch(NotifyErrorWrapper('Failed to fetch possible part statuses')),
    refetchOnWindowFocus: false,
    refetchOnMount: false,
  })

  return { minerStatuses, partStatuses }
}
